"use client";
import { useEffect, useState } from "react";
import { Dog, getPublicDogs } from "./api";
export function useCatalogDogs(){ const [dogs,setDogs]=useState<Dog[]>([]); useEffect(()=>{getPublicDogs().then(setDogs).catch(()=>setDogs([]));},[]); return dogs; }
